/**
 * CSS expression referencing the top-bar height published by `Frame` at runtime
 * via the `--frame-topbar-h` custom property. The 5.5rem fallback matches
 * `libs/product-ui/src/components/Frame/Frame.tsx`'s pre-measure default
 * and applies until the layout effect there publishes the measured value.
 */
export const FRAME_TOPBAR_HEIGHT_VAR = "var(--frame-topbar-h, 5.5rem)";
